import { convertToGAIndex } from '@noths/polaris-client-google-analytics';
var compareNavItems = function compareNavItems(a, b) {
  return a.title === b.title && a.url === b.url;
};
var formatEventLabel = function formatEventLabel(data) {
  return data.join('|');
};
export var getTrackingEventLabel = function getTrackingEventLabel(level1Items, search) {
  // find matching level 1 item
  var level1ItemIndex = level1Items.findIndex(function (level1Item) {
    return compareNavItems(level1Item, search);
  });
  if (level1ItemIndex >= 0) {
    return formatEventLabel([1, convertToGAIndex(level1ItemIndex), level1Items[level1ItemIndex].title]);
  }

  // find matching level 2 item
  for (var level1Index = 0; level1Index < level1Items.length; level1Index++) {
    var level1Item = level1Items[level1Index];
    var level2Index = level1Item.items.findIndex(function (level2Item) {
      return compareNavItems(level2Item, search);
    });
    if (level2Index >= 0) {
      var level2Item = level1Item.items[level2Index];
      return formatEventLabel([1, convertToGAIndex(level1Index), level1Item.title, 2, convertToGAIndex(level2Index), level2Item.title]);
    }
  }

  // find matching level 3 item
  for (var _level1Index = 0; _level1Index < level1Items.length; _level1Index++) {
    var _level1Item = level1Items[_level1Index];
    for (var columnIndex = 0; columnIndex < _level1Item.items.length; columnIndex++) {
      var column = _level1Item.items[columnIndex];
      var level3Index = column.items.findIndex(function (level3Item) {
        return compareNavItems(level3Item, search);
      });
      if (level3Index >= 0) {
        var level3Item = column.items[level3Index];
        return formatEventLabel([1, convertToGAIndex(_level1Index), _level1Item.title, 2, convertToGAIndex(columnIndex), column.title, 3, convertToGAIndex(level3Index), level3Item.title]);
      }
    }
  }
  return null;
};